import React from "react";
import logo from './../../assets/logo.svg';

export function Header() {
    return (
        <div className='flex min-h-full flex-1 flex-col justify-center px-6 py-12 lg:px-8'>
            <div className='sm:mx-auto justify-center flex sm:w-full sm:max-w-sm'>
                <img
                    className='h-10 w-auto'
                    src={logo}
                    alt='XPLANUNG24'
                />
                <span className={'ml-2 mt-1 text-2xl'}>PLANUNG24</span>
            </div>
        </div>
    );
}